var $03712eabbcfd201c$exports = {};
$03712eabbcfd201c$exports = {
    "alert": `\u{8B66}\u{793A}`,
    "dismiss": `\u{95DC}\u{9589}`
};


export {$03712eabbcfd201c$exports as default};
//# sourceMappingURL=zh-TW.module.js.map
